




















































































































































import { Component, Vue, Provide, Watch, Prop } from "vue-property-decorator";
import {
  RollOrderTrialCalcReq,
  RollTCOption,
  RollOrderApplyReq,
  RollOrderCancelReq,
} from "@/pbjs/external/ticket/ticket_pb";
import { ticketClient } from "@/api";
import { localGet, timeFormat } from "@/utils";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import { RollStatus } from "@/pbjs/xcommon/core_pb";

@Component({
  name: "newOrder",
})
export default class CombinationProperty extends Vue {
  @Prop() deferPeriodStatus!: any;
  @Prop() orderId: any;
  @Prop() subOrderid: any;
  @Prop() multi_loan_switch!: any;
  @Prop() ticketData!: any;

  @Prop() deferPeriodInfo: any;
  @Provide() private penaltyData: any = [];
  @Provide() private isReduceTicketDone: boolean = false;
  @Provide() private penaltyForm: any = {
    interest: null,
    penalty: null,
    reason: "",
  };
  @Provide() private delayDayOptions: any = [];
  @Provide() private deferDayValue: any = null;
  @Provide() private currePayAmount: number = 0;
  @Provide() private currePayTime: any = null;
  @Provide() private nextRepayAmount: number = 0;
  @Provide() private nextRepayTime: any = null;
  @Provide() private minRepayAmount: number | null = null;
  @Provide() private onDeferDay: number = 0;
  @Provide() private isReTryCalc: boolean = false;

  private created() {
    if (this.deferPeriodStatus === 1) {
      this.delayDayOptions =
        this.deferPeriodInfo && this.deferPeriodInfo.rolloptionsList;
    } else if (this.deferPeriodStatus === 2) {
      this.onDeferDay = this.deferPeriodInfo.detail.option.rollday;
      this.currePayAmount = this.deferPeriodInfo.detail.currepayamount;
      this.currePayTime = timeFormat(this.deferPeriodInfo.detail.currepaytime);
      this.nextRepayAmount = this.deferPeriodInfo.detail.nextrepayamount;
      this.nextRepayTime = timeFormat(
        this.deferPeriodInfo.detail.nextrepaytime
      );
    }
  }

  @Watch("deferDayValue")
  onDeferPeriodStatusChanged(val: number) {
    if (val) {
      this.rollOrderTrialCalc();
    }
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
  }

  private closeDialog() {
    this.$emit("showDiffTypeDialog", 0);
  }

  private preApplyDeferPeriod() {
    if (!this.minRepayAmount) {
      this.minRepayAmount = this.currePayAmount;
    }
    if (!this.deferDayValue) {
      this.$message.error(this.$tc("v0703.PleaseEnter"));
    } else if (this.minRepayAmount < this.currePayAmount) {
      this.$message.error(
        this.$tc(
          "The input amount must be greater than the minimum repayment amount for the period"
        )
      );
    } else {
      this.$confirm(
        this.$tc(
          "Do you apply for delayed repayment for the user? (Make sure you have negotiated with the user)"
        ),
        "tips",
        {
          confirmButtonText: this.$tc("authority.ok"),
          cancelButtonText: this.$tc("authority.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.rollOrderApply();
      });
    }
  }

  private preCancelDeferPeriod() {
    this.$confirm(
      this.$tc(
        "Whether to cancel the repayment extension application for the user"
      ),
      "tips",
      {
        confirmButtonText: this.$tc("authority.ok"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning",
      }
    ).then(() => {
      this.rollOrderCancel();
    });
  }

  private retryCalc() {
    this.isReTryCalc = true;
    this.rollOrderTrialCalc();
  }

  private rollOrderTrialCalcFuc(data: any) {
    if (data.detail) {
      this.currePayAmount = data.detail.currepayamount;
      this.currePayTime = timeFormat(data.detail.currepaytime);
      this.nextRepayAmount = data.detail.nextrepayamount;
      this.nextRepayTime = timeFormat(data.detail.nextrepaytime);
      this.minRepayAmount = this.currePayAmount;
    }
  }
  private rollOrderTrialCalc() {
    let request: any = new RollOrderTrialCalcReq();
    request.setCommonin(setCommon());
    request.setAppname(this.ticketData.appname);
    if (this.subOrderid) {
      request.setOrderid(this.subOrderid);
    } else {
      request.setOrderid(this.orderId);
    }
    let day: any = new RollTCOption();
    day.setProductid(this.deferDayValue);
    day.setRollday(Number(this.findRollDay()));
    request.setOption(day);
    if (this.isReTryCalc) {
      request.setMinrepayamount(this.minRepayAmount);
    }
    ticketClient.rollOrderTrialCalc(request, {}, (err: any, response: any) => {
      if (response) {
        const data: any = response.toObject();
        let _fuc = this.rollOrderTrialCalcFuc;
        handleResponse(data, _fuc);
        //  if (!data.commonout || (data.commonout.code == 0)) {
        //     if (data.detail) {
        //         this.currePayAmount = data.detail.currepayamount;
        //         this.currePayTime = timeFormat(data.detail.currepaytime);
        //         this.nextRepayAmount = data.detail.nextrepayamount;
        //         this.nextRepayTime = timeFormat(data.detail.nextrepaytime);
        //         this.minRepayAmount = this.currePayAmount;
        //     }
        // } else if (data.code == 100100 || data.code == 100101) {
        //     this.$router.push("./login");
        // } else if (data.commonout.code == 102) {
        //     // this.pagerCount = 0;
        //     // this.resultData = [];
        // } else {
        //     this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private rollOrderCancelFuc(data: any) {
    this.$message.success("Sucess");
    this.$emit("refreshDeferPeriodInfo");
    this.closeDialog();
  }
  private rollOrderCancel() {
    let request: any = new RollOrderCancelReq();
    request.setCommonin(setCommon());
    // request.setOrderid(this.orderId);
    // request.setOrderid(Number(this.subOrderid));
    request.setAppname(this.ticketData.appname);
    if (this.subOrderid) {
      request.setOrderid(this.subOrderid);
    } else {
      request.setOrderid(this.orderId);
    }
    ticketClient.rollOrderCancel(request, {}, (err: any, response: any) => {
      if (response) {
        const data: any = response.toObject();
        let _fuc = this.rollOrderCancelFuc;
        handleResponse(data, _fuc);
        //  if (!data.commonout || (data.commonout.code == 0)) {
        //     this.$message.success("Sucess");
        //     this.$emit("refreshDeferPeriodInfo");
        //     this.closeDialog();
        // } else if (data.code == 100100 || data.code == 100101) {
        //     this.$router.push("./login");
        // } else if (data.commonout.code == 102) {
        //     // this.pagerCount = 0;
        //     // this.resultData = [];
        // } else {
        //     this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private rollOrderApplyFuc(data: any) {
    this.$message.success("Sucess");
    this.$emit("refreshDeferPeriodInfo");
    this.closeDialog();
  }
  private rollOrderApply() {
    let request: any = new RollOrderApplyReq();
    request.setCommonin(setCommon());
    request.setAppname(this.ticketData.appname);
    // request.setOrderid(Number(this.subOrderid));
    if (this.subOrderid) {
      request.setOrderid(this.subOrderid);
    } else {
      request.setOrderid(this.orderId);
    }
    // request.setOrderid(this.orderId);
    let day: any = new RollTCOption();
    day.setProductid(this.deferDayValue);
    day.setRollday(Number(this.findRollDay()));
    request.setOption(day);
    request.setMinrepayamount(this.minRepayAmount);
    ticketClient.rollOrderApply(request, {}, (err: any, response: any) => {
      if (response) {
        const data: any = response.toObject();
        let _fuc = this.rollOrderApplyFuc;
        handleResponse(data, _fuc);
        //  if (!data.commonout || (data.commonout.code == 0)) {
        //     this.$message.success("Sucess");
        //     this.$emit("refreshDeferPeriodInfo");
        //     this.closeDialog();
        // } else if (data.code == 100100 || data.code == 100101) {
        //     this.$router.push("./login");
        // } else if (data.commonout.code == 102) {
        //     // this.pagerCount = 0;
        //     // this.resultData = [];
        // } else {
        //     this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private findRollDay() {
    for (let i = 0; i < this.delayDayOptions.length; i++) {
      if (this.delayDayOptions[i].productid === this.deferDayValue) {
        return this.delayDayOptions[i].rollday;
      }
    }
  }
}
